import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0664d41c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "top__wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "모바일 기능", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" 다양한 기능들로"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("다채로운 서비스를"),
  /*#__PURE__*/_createElementVNode("br", { class: "mbr" }),
  /*#__PURE__*/_createTextVNode(" 제공하세요. ")
], -1))
const _hoisted_5 = { class: "top__wrap__nav" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "active" }, "모바일 기능", -1))
const _hoisted_9 = {
  class: "tab",
  id: "tab"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["id"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "content__img" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "click-area__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-zoom" })
], -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ZoomImg = _resolveComponent("ZoomImg")!
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createBlock(_component_Layout, { onScroll: $setup.onScroll }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
            }, " 홈 "),
            _hoisted_6,
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/health')))
            }, " 헬스케어 플랫폼 "),
            _hoisted_7,
            _hoisted_8
          ])
        ])
      ]),
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabArr, (tab, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: tab.i,
            class: _normalizeClass(
					$setup.activeTab == tab ? 'active' : null
				),
            onClick: ($event: any) => ($setup.scrollToSection(index))
          }, _toDisplayString(tab), 11, _hoisted_10))
        }), 128))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.contents, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "content",
          key: item.i,
          id: 'content' + index
        }, [
          _createElementVNode("h4", null, _toDisplayString(item.category), 1),
          _createElementVNode("h3", {
            innerHTML: item.title
          }, null, 8, _hoisted_12),
          _createElementVNode("p", null, _toDisplayString(item.subtitle), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              src: item.img,
              alt: "image"
            }, null, 8, _hoisted_14),
            _createElementVNode("div", {
              class: "click-area",
              onClick: ($event: any) => (
						[
							($setup.zoomImg = item.img),
							($setup.zoomModalOpen = true),
						]
					)
            }, _hoisted_17, 8, _hoisted_15)
          ])
        ], 8, _hoisted_11))
      }), 128)),
      ($setup.zoomModalOpen)
        ? (_openBlock(), _createBlock(_component_ZoomImg, {
            key: 0,
            onOnClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.zoomModalOpen = false)),
            img: $setup.zoomImg
          }, null, 8, ["img"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onScroll"]))
}